import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';
import { environment } from '../../environments/environment';
import { MonthlyUtilityCostResponse, ServiceCostSaveCommand, ServiceCostSaveResult } from '../models/monthly-uploads/service-cost';

@Injectable({ providedIn: 'root' })
export class ServiceCostProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/monthly-utility-cost';

  public getByPeriod(year: number, month: number): Observable<ApiResponse<MonthlyUtilityCostResponse>> {
    return this.httpClient.get<ApiResponse<MonthlyUtilityCostResponse>>(this.baseUrl, { params: { year, month } });
  }

  public save(command: ServiceCostSaveCommand, file?: File): Observable<ApiResponse<ServiceCostSaveResult>> {
    const formData = new FormData();
    formData.append('Month', String(command.month));
    formData.append('Year', String(command.year));
    formData.append('ServiceType', String(command.serviceType));
    formData.append('InvoiceNumber', command.invoiceNumber);
    formData.append('Currency', String(command.currency));
    formData.append('Value', String(command.value));
    if (file) {
      formData.append('File', file, file.name);
    }
    return this.httpClient.post<ApiResponse<ServiceCostSaveResult>>(`${this.baseUrl}/import-excel`, formData);
  }
}
